import PropTypes from 'prop-types'
import clsx from 'clsx'
import React, { forwardRef } from 'react'
import Tooltip from '@/components/Tooltip'
import { ButtonType } from './Button.type'

const BaseButton = forwardRef(
  (
    {
      dataTestId = 'button',
      text,
      prefixIcon,
      suffixIcon,
      onClick,
      btnClassName,
      disabled,
      tooltipText,
      btnType,
      addbtnClass,
      fullWidth = false,
      id = undefined,
      width,
      ...buttonProps
    },
    ref
  ) => {
    const buttonClass = clsx(
      'DS_button',
      btnType !== ButtonType.UTILITY && 'justify-center max-w-max cursor-pointer',
      btnClassName,
      addbtnClass,
      {
        'DS_button--disabled': disabled,
      }
    )

    const innerButtonClass =
      btnType === ButtonType.UTILITY
        ? 'w-full m-0 p-0 [font:inherit] text-inherit cursor-[inherit] no-underline border-none bg-transparent shadow-none'
        : 'flex items-center p-2 font-avenir type-body-1 text-inherit cursor-[inherit] no-underline border-none bg-transparent shadow-none gap-1.5 h-auto hover:enabled:text-inherit hover:enabled:bg-transparent hover:enabled:border-transparent hover:enabled:[&_svg_path]:fill-grey-50'

    const buttonStyle = width ? { width } : {}

    return (
      <div className={buttonClass} data-testid={dataTestId}>
        <button
          ref={ref}
          className={innerButtonClass}
          onClick={onClick}
          onKeyUp={e => {
            if (btnType === ButtonType.UTILITY && e.key === ' ') {
              e.preventDefault()
            }
          }}
          disabled={disabled}
          style={buttonStyle}
          {...buttonProps}
          type="button"
        >
          {prefixIcon && <span className="prefix-icon">{prefixIcon}</span>}
          {text && (
            <Tooltip
              id={tooltipText || ''}
              content={tooltipText || ''}
              disabled={!tooltipText}
              fullWidth={fullWidth}
            >
              <span className="button-text" id={id}>
                {text}
              </span>
            </Tooltip>
          )}
          {suffixIcon && <span className="suffix-icon">{suffixIcon}</span>}
        </button>
      </div>
    )
  }
)

BaseButton.displayName = 'BaseButton'

BaseButton.propTypes = {
  dataTestId: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  prefixIcon: PropTypes.node,
  suffixIcon: PropTypes.node,
  onClick: PropTypes.func,
  btnClassName: PropTypes.string,
  disabled: PropTypes.bool,
  tooltipText: PropTypes.string,
  btnType: PropTypes.oneOf(Object.values(ButtonType)).isRequired,
  addbtnClass: PropTypes.string,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default BaseButton
